import * as React from 'react';
import { RegisterPromiseType } from 'trashable-react';

type TrashableContextType = {
  registerPromise: RegisterPromiseType;
};

export const TrashableContext = React.createContext<TrashableContextType>(
  // do not initialize so that incorrect usage can be detected by a truthy check
  undefined as any,
);

export const useTrashablePromise = () => {
  const trashable = React.useContext(TrashableContext);

  if (!trashable) {
    console.error(
      `Trashable context is undefined, 
    please verify you are calling useTrashablePromise() 
    as child of a component wrapped with withTrashableContext.`,
    );
  }

  return trashable;
};
